import React from "react";
import Image1920x156 from "../img/thumb/photo-1920x156--2.jpg";
import IconPdf from "../img/icons/icon-pdf.svg";
import {Config} from "../Config";
import * as Utils from "../inc/Utils";

export default function Plan(prop) {

    let [plan, setPlan] = React.useState(null);

    React.useEffect(() => {

        (async function() {
            try {
                const planListing = await getPlanResults();
                setPlan(planListing);
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getPlanResults() {
        const response = await fetch(Config.apiUrl +'plan/list', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                <img src={Image1920x156} alt="" />
                <div className="container">
                    <p data-aos="fade-in"><a href={prop.lang === 'en' ? '/en':'/'}>{prop.lang === 'en' ? 'Home':'หน้าแรก'}</a> / {prop.lang === 'en' ? 'About Us':'เกี่ยวกับ ศชวซ.'} / {prop.lang === 'en' ? 'Plan':'แผนการดำเนินงาน'}</p>
                    <h1 className="h2 textrow">
                        <span data-aos="fade-in">{prop.lang === 'en' ? 'Plan':'แผนการดำเนินงาน'}</span>
                    </h1>
                </div>
            </div>


            <div className="section bg-light">
                <div className="container">
                    <h2 className="text-center text-primary mb-sm-4 mb-3">{prop.lang === 'en' ? 'Plan':'แผนปฏิบัติการระยะ 5 ปี และแผนที่เกี่ยวข้อง'}</h2>

                    <div className="card-infos">
                        {
                            plan !== null && plan.count > 0 ?
                                <ul className="document-list">
                                    {
                                        plan.rows.map((row, index) => {
                                            return (
                                                <li>
                                                    <img className="icons" src={IconPdf} alt="PDF" />
                                                    <div>
                                                        <h3><a href={Config.fileUpload + 'plan/' + row.file} target="_blank">{Utils.cleanOutput(prop.lang === 'en' ? row.title_en:row.title)}</a>
                                                        </h3>
                                                    </div>
                                                </li>
                                            )
                                        })
                                    }
                                </ul> : ''
                        }
                    </div>
                </div>
            </div>
        </>
    );
} 